import { BookNowButtonClicked } from './../../core/store/general/actions';
import { ChangeLoadingStatusAction } from './../../core/store/general/actions';
import { ActivatedRoute } from '@angular/router';
import { SingleResultService } from './../../core/services/single-hotel.service';
import { Observable } from 'rxjs';
import { IMarker } from './../../shared/components/map/map.component';
import { Injectable } from '@angular/core';
import { FacilitiesTabInfo, Checkin, PricingPolicy } from '../results/hotel-single/hotel-single.component';
import { HotelHeaderInfo } from '../../core/store/general/state';
import { HeaderChangeAction } from '../../core/store/general/actions';
import { HotelPreview } from '../results/results.container';
import { AppState } from '../../shared/app-state.container';
import { ResultsService } from '../../core/services/results.service';
import { getLastRequestAsked } from '../../core/store/general/selectors';


@Injectable()
export class BookingContainer {

    /*public isLoggedIn$;
    public header$;
    public hotelTypes$;
    public mealTypes$;
    public exclusiveCategories$;
    public optionalFacilities$;
    public priceRange$ = {
        minPrice: 1000,
        maxPrice: 0
    };
    hotePreviews: Array<HotelPreview>;
    allHotels: Array<HotelPreview>;
    myRequestInfo: IRequest;
    public markers: Array<IMarker>;
    hotels: Array<any>;


    public hotelPrev = new Subject<Array<HotelPreview>>();
    public hotelPreviewsArr$ = this.hotelPrev.asObservable();

    public markersSubj = new Subject<Array<IMarker>>();
    public markersArr$ = this.markersSubj.asObservable();*/

    facilitiesTab: FacilitiesTabInfo;
    offerInfo;
    languages = new Array<string>();
    checkinout: Checkin;
    pricingPolicy: PricingPolicy;
    offerNote: String;
    user;
    bookingRequest;
    hotelInfo: HotelHeaderInfo;
    selectedRooms = new Array();
    finalRooms = new Array();
    mapInformation;
    cardsAccepted: any;

    satisfiedWishes: Map<Number, String>;
    finalWishes: Map<String, Boolean>;
    selectedExps: Map<Number, String>;

    // initialization for experiences
    experiencesMappingRest = [
        { id: 7, name: 'Love to explore the local cuisine', checked: false, position: 1 },
        { id: 35, name: 'Looking for pet-friendly accommondation', checked: false, position: 2 },
        { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
        { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
        { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
        { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
        { id: 15, name: 'Wanting a workspace, got some work to do', checked: false, position: 7 },
        { id: 4, name: 'Want to spend precious time with my family', checked: false, position: 8 },
        { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
        { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
        { id: 20, name: 'Would love to be transfered from and to the airport', checked: false, position: 11 },
        { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
        { id: 13, name: 'Host our guests and/or our wedding party', checked: false, position: 13 },
        { id: 8, name: 'Want to experience the local way of life', checked: false, position: 14 },
        { id: 24, name: 'Want to explore the landmarks, sites and local history ', checked: false, position: 15 },
        { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
        { id: 2, name: 'I want to enjoy the warm sun and the golden beaches', checked: false, position: 17 },
        { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
    ];

    totalDays;

    guestEmail: String;

    requestForSearch;
    offerId;
    constructor(
        protected sharedContainer: AppState,
        private service: SingleResultService, private resultsService: ResultsService,
        private route: ActivatedRoute
    ) {
        // this.offerId = this.route.pathFromRoot[1].snapshot.paramMap.get('id');
        this.route.params.subscribe(params => {
            if (params['id']) {
                this.offerId = params['id'];
            }
        });
        this.satisfiedWishes = new Map<Number, String>();
        this.selectedExps = new Map<Number, String>();
    }

    populateWithData(id) {
        this.offerId = id;
        // this.enableSpinner(true);
        this.sharedContainer.generalState$.select(getLastRequestAsked).subscribe((request) => {
            if (request) {
                this.fillRequestForSearch(request);
                this.requestForSearch.hotelid = this.offerId;
            }
            this.resultsService.getProperty(this.requestForSearch).subscribe(offer => {
                this.offerInfo = offer;
                // this.bookingRequest = offer.offer.bookingRequest;
                this.fillFacilities(offer);
                this.fillLanguages();
                this.fillHotelInfo(offer);
                this.fillCheckinInfo();
                // this.fillCancellationPolicy(offer);
                this.fillSelectedRooms(offer);
                this.fillMapInformation(offer);
                // this.enableSpinner(false);
            });
        });
        // this.service.getOffer(this.offerId).subscribe(offer => {
    }

    getNightsDifference(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    fillRequestForSearch(data) {
        // const fromDate = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day + 1);
        // const toDate = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day + 1);

        // const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
        // const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

        this.requestForSearch = {
            fromdate: data.fromdate,
            todate: data.todate,
            rooms: data.rooms,
            persons: data.roompersons, // this.roompersons
            hotelextras: data.hotelextras,
            offset: 0,
            limit: 10,
            offerid: data.userid,
            userid: this.getUserId(),
            totalprice: data.maxprice
        };

        this.totalDays = this.getNightsDifference(data.fromdate, data.todate);

    }
    changeHeaderType(type) {
        this.sharedContainer.generalState$.dispatch(new HeaderChangeAction(1, { headerType: type }));
    }

    fillMapInformation(offer) {
        const marker: IMarker = {
            label: offer.hotel.id,
            lat: offer.hotel.latitude,
            lng: offer.hotel.longitude,
            draggable: false
        };
        const markers = new Array(marker);
        this.mapInformation = new Object();
        this.mapInformation.markers = markers;
        /*this.mapInformation.mapCenter = {latitude: offer.offer.bookingRequest.latitude,
                                longitude: offer.offer.bookingRequest.longitude};*/
        const hotelPreview: HotelPreview = {
            minPrice: 10000,
            title: '',
            pictures: [],
            description: '',
            stars: -1,
            reviews: 0,
            experiences: [],
            optionaRequests: [],
            id: -1,
            offerId: -1,
            offerType: ''
        };
        hotelPreview.title = offer.hotel.name;
        hotelPreview.stars = offer.hotel.starRating;
        hotelPreview.reviews = offer.reviews;
        hotelPreview.pictures = offer.propertyPics;
        hotelPreview.experiences = offer.extras;
        hotelPreview.id = offer.hotel.id;
        hotelPreview.offerId = offer.hotel.id;
        hotelPreview.offerType = 'Hotel';
        hotelPreview.minPrice = offer.dailyCharge;
        // hotelPreview.offerType = offer.offer.bidType.id === 2 ? 'Offer' : 'Hotel';
        /*offer.offer.bookingOfferRoomCollection.map( room => {
            if (room.availableRooms > 0) {
                if (hotelPreview.minPrice > room.offerPrice) { hotelPreview.minPrice = room.offerPrice; }
            }
        });*/
        const hotelPreviews: Array<HotelPreview> = new Array(hotelPreview);
        this.mapInformation.hotels = hotelPreviews;
        this.mapInformation.hasInfoWindow = false;
    }

    getMapInfo() {
        return this.mapInformation;
    }

    fillFacilities(offerInfo) {
        this.facilitiesTab = {
            general: offerInfo.hotel.hotelFacilitiesCollection.filter(
                facility => facility.facility.facilityGroupName === 'General').map(facility => facility.facility.name),
            activities: offerInfo.hotel.hotelFacilitiesCollection.filter(
                facility => facility.facility.facilityGroupName === 'Activities').map(facility => facility.facility.name),
            services: offerInfo.hotel.hotelFacilitiesCollection.filter(
                facility => facility.facility.facilityGroupName === 'Services').map(facility => facility.facility.name),

        };
    }

    fillHotelInfo(offerInfo) {
        this.hotelInfo = {
            title: offerInfo.hotel.name, stars: offerInfo.hotel.starRating,
            location: offerInfo.hotel.addressLine1 + ',' + offerInfo.hotel.addressCity + ',' + offerInfo.hotel.country,
            cost: 0
        };
    }

    retrieveExtras(room, bookedExtra, type) {
        let selectedExtra1;
        let selectedExtra2;
        if (type === 'extra') {
            selectedExtra1 = this.offerInfo.extras.find(extra => extra.id === bookedExtra.bookingOfferExtraId);
            selectedExtra2 = room.roomExtras.find(extra => extra.id === bookedExtra.bookingOfferExtraId);
        } else {
            selectedExtra1 = this.offerInfo.extras.find(extra => {
                if (extra.hotelMeal === null) { return false; }
                return extra.hotelMeal.id === bookedExtra.bookingOfferMealId;
            });
            selectedExtra2 = room.roomExtras.find(extra => {
                if (extra.hotelMeal === null) { return false; }
                return extra.hotelMeal.id === bookedExtra.bookingOfferMealId;
            });
        }

        if (selectedExtra1) {
            selectedExtra1.quantity = bookedExtra.quantity;
            selectedExtra1.price = bookedExtra.price;
            return selectedExtra1;
        }
        if (selectedExtra2) {
            selectedExtra2.quantity = bookedExtra.quantity;
            selectedExtra2.price = bookedExtra.price;
            return selectedExtra2;
        }
    }

    calculateWishes() {

        this.finalWishes = new Map<String, Boolean>();
        if (this.satisfiedWishes.size > 0) {
            this.satisfiedWishes.forEach((key, value) => {

                this.selectedExps.forEach((value2: String, id2: Number) => {
                    if (value === id2) {
                        this.finalWishes.set(key, true);
                        this.selectedExps.delete(id2);
                    }
                });

            });
            this.selectedExps.forEach((value: String, key: Number) => {
                this.finalWishes.set(value, false);
            });
        }

    }

    fillSelectedRooms(offerInfo) {

        this.cardsAccepted = offerInfo.creditCards;

        this.offerNote = offerInfo.offer.personalRequestResponse;
        if (offerInfo.offer.wishesSatisfied && offerInfo.offer.bookingRequest.bookingRequestExtrasCollection.length > 0) {
            const satWishes = offerInfo.offer.wishesSatisfied.split(',');
            for (let i = 0; i < satWishes.length; i++) {
                for (let j = 0; j < this.experiencesMappingRest.length; j++) {
                    if (parseInt(satWishes[i], 10) === this.experiencesMappingRest[j].id) {
                        const id = this.experiencesMappingRest[j].id;
                        this.satisfiedWishes.set(id, this.experiencesMappingRest[j].name);
                    }
                }
            }
            const requestExperiences = offerInfo.offer.bookingRequest.bookingRequestExtrasCollection;
            for (let i = 0; i < requestExperiences.length; i++) {
                this.selectedExps.set(parseInt(requestExperiences[i].bookingExtraCategory.id, 10),
                    requestExperiences[i].bookingExtraCategory.category);
            }
            setTimeout(() => {
                this.calculateWishes();
            }, 2000);
        }
        this.finalRooms = new Array();
        this.selectedRooms = new Array();
        offerInfo.offerRooms.forEach(room => {
            this.service.getRoomInfo(room.room.id).subscribe(roomInfo => {
                if (roomInfo.isSelected) {
                    let selectedExtras = [];
                    roomInfo.bookingOfferRoomSelectedExtras.forEach(bookedExtra => {
                        selectedExtras.push(this.retrieveExtras(room, bookedExtra, 'extra'));
                    });
                    room.selectedExtras = selectedExtras;

                    selectedExtras = [];
                    selectedExtras = roomInfo.bookingOfferRoomSelectedMeals;
                    /*roomInfo.bookingOfferRoomSelectedMeals.forEach(meal => {
                        selectedExtras.push(this.retrieveExtras(room, meal, 'meal'));
                    });*/
                    room.selectedMeals = selectedExtras;
                    this.selectedRooms.push(room);

                    // create room to show on booking page bellow
                    const roomData: RoomTypeFinal[] = [
                        {
                            id: room.room.id,
                            name: room.room.roomType.name,
                            rateType: room.room.isNonRefRoom,
                            offerPrice: room.room.offerPrice,
                            defaultPrice: room.room.defaultPrice,
                            nonRefPrice: room.room.nonRefundablePrice,
                            selectedExtrasToShow: room.selectedExtras,
                            selectedRooms: roomInfo.selectedRooms,
                            pricingPolicy: room.room.pricingPolicy,
                            cancellationPolicy: room.room.cancellationPolicy
                        }
                    ];

                    // we get true or false for room rate so we translate boolean to string bellow
                    if (room.room.offerPrice !== room.room.defaultPrice) {
                        roomData[0].rateType = 'Standard room price';
                    } else {
                        if (roomData[0].rateType === true) {
                            roomData[0].rateType = 'Standard room price ';
                        } else {
                            // roomData[0].rateType = 'Non Refundable room price ';
                            roomData[0].rateType = 'Standard room price '; // temporal fix cause nonRef is currently removed
                        }
                    }

                    this.finalRooms.push(roomData);

                    // if we find same room name, that means both standard & non refundable rates are chosen
                    // so we remove one room and add all attributes to other for display purposes
                    for (let i = 0; i < this.finalRooms.length; i++) {
                        const room0 = this.finalRooms[i][0];
                        for (let j = i + 1; j < this.finalRooms.length; j++) {
                            const room1 = this.finalRooms[j][0];
                            if (room0.name === room1.name) {
                                room1.offerPrice += room0.offerPrice;
                                room1.rateType = 'Standard room price ' + room0.defaultPrice + '€\n' +
                                    'NonRefundable room price ' + room0.nonRefPrice + '€';
                                this.finalRooms.splice(i, 1);
                                continue;
                            }
                        }
                    }
                }
            });
        });
    }

    fillCheckinInfo() {
        this.checkinout = {
            checkInTimeFrom: this.offerInfo.hotel.checkInTimeFrom,
            checkInTimeUntil: this.offerInfo.hotel.checkInTimeUntil,
            checkOutTimeFrom: this.offerInfo.hotel.checkOutTimeFrom,
            checkOutTimeUntil: this.offerInfo.hotel.checkOutTimeUntil
        };
    }

    getNightsSafari(from, to) {
        const fromDate = from.replace(/-/g, '/');
        const toDate = to.replace(/-/g, '/');
        const date1 = new Date(fromDate);
        const date2 = new Date(toDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    fillLanguages() {
        this.languages = this.offerInfo.hotelLanguages.map(language => language.language.language);
    }

    fillCancellationPolicy(offerInfo) {
        const despositPercent = offerInfo.offer.pricingPolicy.depositPercent;
        const freeCancellation = offerInfo.offer.cancellationPolicy.freeCancellation;
        const nonRefundable = offerInfo.offer.cancellationPolicy.nonRefundable;

        const noShow = offerInfo.offer.cancellationPolicy.noShow;
        const cancellationPolicyDays = offerInfo.offer.cancellationPolicy.hotelCancellationPolicyDaysCollection;

        let cancellationTitle = '';
        let alternativeTitle = '';
        const cancellationText = new Array<string>();

        if (freeCancellation) {
            cancellationTitle = '';
            alternativeTitle = 'Free Cancellation';
        } else if (nonRefundable) {
            cancellationTitle = 'Non Refundable';
            alternativeTitle = 'No Refund on Cancellation';
        } else {
            cancellationTitle = 'With Cancellation';
            cancellationText.push(despositPercent + '% Deposit');
            cancellationText.push(noShow + '% No-show');

            cancellationPolicyDays.map(policyDays => {
                cancellationText.push(policyDays.feePercent + '% Cancellation fee prior to ' + policyDays.daysLessThan + ' days');
            });
        }

        const childrenOffers = new Array<string>();
        this.offerInfo.childrenOfferType.map(childrenType => {
            if (childrenType.applyDiscount) {
                childrenOffers.push('Free! All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + (childrenType.childrenMaxAge !== 1) ? 's' : '' +
                ' stay free of charge for children\'s cots/cribs.');
            } else {
                const sornot = (childrenType.childrenMaxAge !== 1) ? 's' : '';
                childrenOffers.push('All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + sornot +
                    ' have ' + childrenType.hotelAutomatedOfferChildrenTypeDiscountCollection[0].discountPercentage +
                    ' for children\'s cots/cribs.');
            }
        });

        this.pricingPolicy = {
            title: cancellationTitle,
            alternativeTitle: alternativeTitle,
            titleTooltip: cancellationText,
            cancelationPrepayment: cancellationText,
            childrenOffers: childrenOffers
        };



    }

    saveServiceData(serviceData): Observable<any> {
        return this.service.saveServiceData(serviceData);
    }

    saveBookOffer(offer): Observable<any> {
        return this.service.saveBookingOffer(offer.id, offer);
    }

    saveBookOfferSD(offer): Observable<any> {
        return this.service.saveBookingOfferSD(offer.id, offer);
    }

    saveRoomOffer(roomOffer): Observable<any> {
        return this.service.saveRoomOffer(roomOffer.id, roomOffer);
    }
    saveRoomNew(roomOffer): Observable<any> {
        return this.resultsService.goToBooking(roomOffer.id, this.requestForSearch, roomOffer);
    }

    enableSpinner(enabled) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, { isLoading: enabled }));
    }

    sendMessage(messageText) {
        const message = {
            timeSent: new Date(),
            text: messageText,
            seqNo: 0,
            read: false,
            customerId: this.getUserId(),
            threadId: 0,
        };
        if (messageText === null) {
            delete message.text;
            message.read = true;
        }
        const threadData = {
            created: new Date(),
            hotel: this.offerInfo.hotel.id,
            messageCollection: new Array(),
            modified: new Date(),
            title: '[Reservation: ' + this.offerInfo.hotel.id.toString().padStart(6, '0') + '-' +
                this.offerId.toString().padStart(6, '0') + ']'
        };
        this.service.sendMessage(threadData).subscribe(reply => {
            if (reply['messageCollection'] !== null && messageText === null && reply['messageCollection'].length > 0) {
                return;
            }
            message.threadId = reply['id'];
            reply['messageCollection'].push(message);
            reply['hotel'] = this.offerInfo.hotel.id;

            this.service.initThread(reply, reply['id']).subscribe(answer => {
            });
        });

    }

    setBookNowClickedState(isClicked) {
        this.sharedContainer.generalState$.dispatch(new BookNowButtonClicked(1, { bookNowBtnClicked: isClicked }));
    }

    getUserInfo() {
        const user = localStorage.getItem('user');
        return JSON.parse(user);
    }

    getUserId() {
        const user = localStorage.getItem('user');
        return JSON.parse(user).id;
    }

    sendConfirmationEmail(offerId, email) {
        this.service.sendConfirmationEmail(offerId, email).subscribe(reply => console.log(reply));
    }

}

export interface RoomTypeFinal {
    id: any;
    name: any;
    rateType: any;
    offerPrice: any;
    defaultPrice: any;
    nonRefPrice: any;
    selectedExtrasToShow: any;
    selectedRooms: any;
    pricingPolicy?: any;
    cancellationPolicy?: any;
    damageDeposit?: any;
}


